const $$splitErrorComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/integrations/jira/callback.tsx?tsr-split=errorComponent');
const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/integrations/jira/callback.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { oauthCallbackSchema } from '../-shared/useOAuthCallback';

// Permanent alias: the Jira OAuth redirect URI is exact-match registered in the IdP, so this static
// path must keep resolving for in-flight authorizations. It delegates to the same shared handler as
// the canonical /integrations/$provider/callback route with the provider pinned to Jira.

export const Route = createFileRoute('/(app)/integrations/jira/callback')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: zodValidator(oauthCallbackSchema),
  loaderDeps: ({
    search: {
      state,
      code
    }
  }) => ({
    state,
    code
  }),
  errorComponent: lazyRouteComponent($$splitErrorComponentImporter, 'errorComponent')
});